// Client-side copy of weeks data for search functionality
export const WEEKS_DATA = [
  {
    week_number: 1,
    theme: "Foundation and Mindset",
    daily_tasks: [
      { id: "w1d1", day: 1, title: "Set Your Intentions", description: "Define your goals for this journey" },
      { id: "w1d2", day: 2, title: "Morning Affirmations", description: "Start your day with positive self-talk" },
      { id: "w1d3", day: 3, title: "Gratitude Practice", description: "List 5 things you're grateful for" },
      { id: "w1d4", day: 4, title: "Mindful Breathing", description: "Practice 10 minutes of deep breathing" },
      { id: "w1d5", day: 5, title: "Vision Board", description: "Create a visual representation of your goals" },
      { id: "w1d6", day: 6, title: "Self-Compassion", description: "Write a letter of kindness to yourself" },
      { id: "w1d7", day: 7, title: "Weekly Reflection", description: "Review your progress and insights" }
    ]
  },
  {
    week_number: 2,
    theme: "Nourishing Your Body",
    daily_tasks: [
      { id: "w2d1", day: 1, title: "Hydration Focus", description: "Drink 8 glasses of water today" },
      { id: "w2d2", day: 2, title: "Colorful Plate", description: "Eat foods of at least 5 different colors" },
      { id: "w2d3", day: 3, title: "Mindful Eating", description: "Eat one meal without distractions" },
      { id: "w2d4", day: 4, title: "New Healthy Recipe", description: "Try cooking something nutritious" },
      { id: "w2d5", day: 5, title: "Sugar Awareness", description: "Track your sugar intake today" },
      { id: "w2d6", day: 6, title: "Meal Prep", description: "Prepare healthy meals for the week" },
      { id: "w2d7", day: 7, title: "Weekly Reflection", description: "Review your nutrition journey" }
    ]
  },
  {
    week_number: 3,
    theme: "Movement and Energy",
    daily_tasks: [
      { id: "w3d1", day: 1, title: "Morning Stretch", description: "10-minute gentle stretching routine" },
      { id: "w3d2", day: 2, title: "Nature Walk", description: "Take a 30-minute walk outdoors" },
      { id: "w3d3", day: 3, title: "Dance Break", description: "Dance to your favorite songs for 15 minutes" },
      { id: "w3d4", day: 4, title: "Strength Training", description: "Do bodyweight exercises" },
      { id: "w3d5", day: 5, title: "Yoga Practice", description: "Follow a beginner yoga video" },
      { id: "w3d6", day: 6, title: "Active Adventure", description: "Try a new physical activity" },
      { id: "w3d7", day: 7, title: "Weekly Reflection", description: "Review how movement made you feel" }
    ]
  },
  {
    week_number: 4,
    theme: "Rest and Recovery",
    daily_tasks: [
      { id: "w4d1", day: 1, title: "Sleep Sanctuary", description: "Optimize your bedroom for better sleep" },
      { id: "w4d2", day: 2, title: "Digital Sunset", description: "No screens 1 hour before bed" },
      { id: "w4d3", day: 3, title: "Relaxation Ritual", description: "Create a calming bedtime routine" },
      { id: "w4d4", day: 4, title: "Power Nap", description: "Take a 20-minute restorative nap" },
      { id: "w4d5", day: 5, title: "Stress Release", description: "Practice progressive muscle relaxation" },
      { id: "w4d6", day: 6, title: "Self-Care Day", description: "Dedicate time to pampering yourself" },
      { id: "w4d7", day: 7, title: "Weekly Reflection", description: "Review your rest and energy levels" }
    ]
  },
  {
    week_number: 5,
    theme: "Emotional Wellness",
    daily_tasks: [
      { id: "w5d1", day: 1, title: "Emotion Check-In", description: "Name and acknowledge your feelings" },
      { id: "w5d2", day: 2, title: "Journaling Deep Dive", description: "Write about a challenging emotion" },
      { id: "w5d3", day: 3, title: "Boundary Setting", description: "Identify one boundary to establish" },
      { id: "w5d4", day: 4, title: "Forgiveness Practice", description: "Work on releasing past hurts" },
      { id: "w5d5", day: 5, title: "Joy Inventory", description: "List activities that bring you joy" },
      { id: "w5d6", day: 6, title: "Emotional Support", description: "Reach out to someone you trust" },
      { id: "w5d7", day: 7, title: "Weekly Reflection", description: "Review your emotional growth" }
    ]
  },
  {
    week_number: 6,
    theme: "Relationships and Connection",
    daily_tasks: [
      { id: "w6d1", day: 1, title: "Gratitude Call", description: "Call someone to express appreciation" },
      { id: "w6d2", day: 2, title: "Active Listening", description: "Practice fully present listening" },
      { id: "w6d3", day: 3, title: "Random Kindness", description: "Perform an unexpected act of kindness" },
      { id: "w6d4", day: 4, title: "Quality Time", description: "Spend uninterrupted time with loved ones" },
      { id: "w6d5", day: 5, title: "Letter Writing", description: "Write a heartfelt letter to someone" },
      { id: "w6d6", day: 6, title: "Community Connection", description: "Engage with your local community" },
      { id: "w6d7", day: 7, title: "Weekly Reflection", description: "Review your relationship growth" }
    ]
  },
  {
    week_number: 7,
    theme: "Purpose and Passion",
    daily_tasks: [
      { id: "w7d1", day: 1, title: "Values Exploration", description: "Identify your core values" },
      { id: "w7d2", day: 2, title: "Passion Discovery", description: "Explore what excites you" },
      { id: "w7d3", day: 3, title: "Skills Inventory", description: "List your unique talents and skills" },
      { id: "w7d4", day: 4, title: "Dream Big", description: "Envision your ideal life without limits" },
      { id: "w7d5", day: 5, title: "Small Steps", description: "Take one action toward a dream" },
      { id: "w7d6", day: 6, title: "Mentorship", description: "Learn from someone you admire" },
      { id: "w7d7", day: 7, title: "Weekly Reflection", description: "Review your purpose journey" }
    ]
  },
  {
    week_number: 8,
    theme: "Financial Wellness",
    daily_tasks: [
      { id: "w8d1", day: 1, title: "Money Mindset", description: "Examine your beliefs about money" },
      { id: "w8d2", day: 2, title: "Budget Review", description: "Assess your current spending" },
      { id: "w8d3", day: 3, title: "Savings Goal", description: "Set a specific savings target" },
      { id: "w8d4", day: 4, title: "Declutter and Sell", description: "Sell items you no longer need" },
      { id: "w8d5", day: 5, title: "Financial Education", description: "Learn about investing basics" },
      { id: "w8d6", day: 6, title: "Generosity Practice", description: "Give to a cause you care about" },
      { id: "w8d7", day: 7, title: "Weekly Reflection", description: "Review your financial wellness" }
    ]
  },
  {
    week_number: 9,
    theme: "Creativity and Expression",
    daily_tasks: [
      { id: "w9d1", day: 1, title: "Creative Play", description: "Engage in art without judgment" },
      { id: "w9d2", day: 2, title: "Write Your Story", description: "Journal about your life narrative" },
      { id: "w9d3", day: 3, title: "Music and Movement", description: "Express yourself through music" },
      { id: "w9d4", day: 4, title: "Photography Walk", description: "Capture beauty in everyday moments" },
      { id: "w9d5", day: 5, title: "Creative Problem Solving", description: "Approach a challenge creatively" },
      { id: "w9d6", day: 6, title: "Share Your Art", description: "Share something you've created" },
      { id: "w9d7", day: 7, title: "Weekly Reflection", description: "Review your creative expression" }
    ]
  },
  {
    week_number: 10,
    theme: "Spiritual Growth",
    daily_tasks: [
      { id: "w10d1", day: 1, title: "Meditation Practice", description: "Sit in stillness for 15 minutes" },
      { id: "w10d2", day: 2, title: "Nature Connection", description: "Spend time in nature mindfully" },
      { id: "w10d3", day: 3, title: "Gratitude Meditation", description: "Meditate on things you're grateful for" },
      { id: "w10d4", day: 4, title: "Sacred Reading", description: "Read spiritual or inspirational texts" },
      { id: "w10d5", day: 5, title: "Acts of Service", description: "Serve others with a open heart" },
      { id: "w10d6", day: 6, title: "Inner Silence", description: "Practice a day of minimal talking" },
      { id: "w10d7", day: 7, title: "Weekly Reflection", description: "Review your spiritual journey" }
    ]
  },
  {
    week_number: 11,
    theme: "Integration and Balance",
    daily_tasks: [
      { id: "w11d1", day: 1, title: "Life Wheel Assessment", description: "Evaluate all areas of your life" },
      { id: "w11d2", day: 2, title: "Time Audit", description: "Track how you spend your time" },
      { id: "w11d3", day: 3, title: "Priority Setting", description: "Identify your top priorities" },
      { id: "w11d4", day: 4, title: "Boundaries Revisited", description: "Strengthen your boundaries" },
      { id: "w11d5", day: 5, title: "Energy Management", description: "Optimize your daily energy" },
      { id: "w11d6", day: 6, title: "Simplify", description: "Remove unnecessary complexity" },
      { id: "w11d7", day: 7, title: "Weekly Reflection", description: "Review your life balance" }
    ]
  },
  {
    week_number: 12,
    theme: "Celebration and Continuation",
    daily_tasks: [
      { id: "w12d1", day: 1, title: "Journey Review", description: "Review your 12-week transformation" },
      { id: "w12d2", day: 2, title: "Wins Celebration", description: "Celebrate all your accomplishments" },
      { id: "w12d3", day: 3, title: "Lessons Learned", description: "Document key insights and lessons" },
      { id: "w12d4", day: 4, title: "Future Vision", description: "Set intentions for the next chapter" },
      { id: "w12d5", day: 5, title: "Gratitude Letter", description: "Write to yourself about this journey" },
      { id: "w12d6", day: 6, title: "Share Your Story", description: "Inspire others with your transformation" },
      { id: "w12d7", day: 7, title: "Completion Ceremony", description: "Honor your achievement and growth" }
    ]
  }
];
